module.exports = __webpack_public_path__ + "static/media/09_720.feb0eee2.jpeg";